"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _domElement = _interopRequireDefault(require("../../utils/propTypes/domElement"));

var SubtreeLayer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SubtreeLayer, _React$Component);

  function SubtreeLayer() {
    (0, _classCallCheck2.default)(this, SubtreeLayer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubtreeLayer).apply(this, arguments));
  }

  (0, _createClass2.default)(SubtreeLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSubtree();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateSubtree();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
          element = _this$props.element,
          renderTree = _this$props.renderTree;
      var closeTransitionTree = renderTree(null);

      if (closeTransitionTree) {
        _reactDom.default.unstable_renderSubtreeIntoContainer(this, closeTransitionTree, element);
      }
    }
  }, {
    key: "updateSubtree",
    value: function updateSubtree() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          element = _this$props2.element,
          renderTree = _this$props2.renderTree;

      _reactDom.default.unstable_renderSubtreeIntoContainer(this, renderTree(children), element);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return SubtreeLayer;
}(_react.default.Component);

SubtreeLayer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  element: _domElement.default.isRequired,
  renderTree: _react.PropTypes.func.isRequired
};
var _default = SubtreeLayer;
exports.default = _default;
module.exports = exports.default;